export default __webpack_public_path__ + "static/media/settings-grey.0a7ad58f.svg";